// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"J7-z"};